import MoneyMovementLocationsSection from '../../money-movement-locations-section/money-movement-locations-section.component';
import { useTranslation } from 'react-i18next';
import { AchLocationType } from 'api/giftcard-ach-service/giftcard-ach-service.types';

type PoolLocationSectionProps = {
  locations: AchLocationType[];
  isLoading: boolean;
};

const PoolLocationSection = ({
  locations,
  isLoading,
}: PoolLocationSectionProps) => {
  const { t } = useTranslation();

  return (
    <MoneyMovementLocationsSection
      title={t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.poolLocation.title',
      )}
      locations={locations}
      transferTypeTitle={t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.headers.enableClientTransfers',
      )}
      isLoading={isLoading}
      data-testid="PoolLocationSection"
    />
  );
};

export default PoolLocationSection;
